import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=21052a5d&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=21052a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21052a5d",
  null
  
)

export default component.exports